$(document).ready(function () {
  "use strict";

  // sticky-add-to-cart-section js start--
  $(window).on("load scroll", function () {
    var scrolling = $(this).scrollTop();
    if (scrolling > 330) {
      $(".sticky-add-to-cart-section").addClass("fixed");
    } else {
      $(".sticky-add-to-cart-section").removeClass("fixed");
    }
  });
  // sticky-add-to-cart-section js end--

  // product varient js start--
  $(".label-accordion-btn").click(function (event) {
    event.stopPropagation();
    $(this).next().slideDown();
    // $(this).parent().parent().siblings().find(".label-content-bottom").slideUp();
    $(".product-bundle-btn").slideUp();
  });
  // product varient js end--

  // **..product-accordion js start..**
  $(".product-accordion-toggle-btn").on("click", function () {
    $(this).next().slideToggle();
    $(this).parent().toggleClass("active");
    $(this)
      .parent()
      .siblings()
      .removeClass("active")
      .find(".product-accordion-item-content")
      .slideUp();
  });
  // **..product-accordion js end..**

  // **..faq-accordion js start..**
  $(".faq-accordion-toggle-btn").on("click", function () {
    $(this).next().slideToggle();
    $(this).parent().toggleClass("active");
    $(this)
      .parent()
      .siblings()
      .removeClass("active")
      .find(".faq-accordion-item-content")
      .slideUp();
  });
  // **..faq-accordion js end..**

  // hotspot banner js start---
  $(".hotspot-input").change(function () {
    if ($(this).is(":checked")) {
      $(".hotspot-wrapper").addClass("hotspot-blur");
    } else {
      $(".hotspot-wrapper").removeClass("hotspot-blur");
    }
  });
  // hotspot banner js end---

  // switch-tab-section js start----
  $("#switch_toggle_btn").on("click", function () {
    $(".switch-tab-item").toggleClass("active");
  });
  // switch-tab-section js end----
});

// timeline js start---
const timeline = document.querySelector(".timeline-items");
const timelineLine = document.querySelector(".timeline-line");
const items = document.querySelectorAll(".timeline-item");

function animateTimelineLine() {
  let lastVisibleIndex = -1;
  const viewportHeight = window.innerHeight;

  // Adjust threshold for mobile devices
  const threshold = window.innerWidth <= 768 ? 0.5 : 0.4; // 50% for mobile, 30% for desktop

  items.forEach((item, index) => {
    const itemTop = item.getBoundingClientRect().top;

    if (itemTop < viewportHeight * threshold) {
      item.classList.add("visible");
      lastVisibleIndex = index;
    } else {
      item.classList.remove("visible");
    }
  });

  if (lastVisibleIndex >= 0) {
    const lastItem = items[lastVisibleIndex];
    const lineTop = timeline.getBoundingClientRect().top;
    const lastItemMiddle = lastItem.offsetTop + lastItem.offsetHeight / 2;

    const heightInPercent = (lastItemMiddle / timeline.offsetHeight) * 100;
    timelineLine.style.height = `${heightInPercent}%`;
  } else {
    timelineLine.style.height = "0%";
  }
}

window.addEventListener("scroll", animateTimelineLine);
window.addEventListener("load", animateTimelineLine);

// timeline js end---

// product-slider js start---
var swiper = new Swiper(".single-product-slider-thumb", {
  loop: false,
  spaceBetween: 10,
  slidesPerView: 7,
  grabCursor: true,
  breakpoints: {
    // when window width is >= 320px
    1: {
      spaceBetween: 10,
      slidesPerView: 5,
    },
    // when window width is >= 576px
    576: {
      spaceBetween: 10,
      slidesPerView: 5,
    },
    // when window width is >= 768px
    768: {
      spaceBetween: 16,
      slidesPerView: 5,
    },
    // when window width is >= 768px
    1151: {
      spaceBetween: 16,
      slidesPerView: 7,
    },
  },
});
var swiper2 = new Swiper(".single-product-slider", {
  loop: false,
  autoHeight: true,
  grabCursor: true,
  autoHeight: true,
  spaceBetween: 0,
  effect: "fade",
  thumbs: {
    swiper: swiper,
  },
  navigation: {
    nextEl: ".swiper-button-next",
    prevEl: ".swiper-button-prev",
  },
});
// product-slider js end---

// single-product-testimonial slider js start----
var swiper = new Swiper(".single-product-testimonial-slider", {
  loop: true,
  spaceBetween: 0,
  slidesPerView: 1,
  autoplay: {
    delay: 2500,
    disableOnInteraction: false,
  },
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
});
// single-product-testimonial slider js end----

// switch-tab slider js start----

let mySwiper;

function tab_slide() {
  if (mySwiper) mySwiper.destroy(true, true); // cleanup
  mySwiper = new Swiper(".switch-tab-slider", {
    loop: true,
    spaceBetween: 0,
    slidesPerView: 1,
    pagination: {
      el: ".swiper-pagination",
      clickable: true,
    },
    navigation: {
      nextEl: ".swiper-button-next",
      prevEl: ".swiper-button-prev",
    },
  });
}

// switch-tab slider js end----

// phases slider js start----

function phases() {
  var swiper = new Swiper(".phases-slider", {
    loop: false,
    spaceBetween: 0,
    slidesPerView: 3,
    navigation: {
      nextEl: ".phases-slider-btn-next",
      prevEl: ".phases-slider-btn-prev",
    },
    breakpoints: {
      // when window width is >= 1px
      1: {
        slidesPerView: 1,
      },
      // when window width is >= 576px
      576: {
        slidesPerView: 2,
      },
      // when window width is >= 768px
      768: {
        slidesPerView: 2,
      },
      // when window width is >= 993px
      993: {
        slidesPerView: 3,
      },
    },
  });
}

// phases slider js end----

document.addEventListener("DOMContentLoaded", function () {
  phases();
  tab_slide();
});

// Re-init Swiper when customizing in theme editor
document.addEventListener("shopify:section:load", function () {
  phases();
  tab_slide();
});

document.addEventListener("shopify:section:select", function () {
  phases();
  tab_slide();
});

$(document).ready(function () {
  phases();
  tab_slide();

  $(".bundle_input").on("change", function () {
    var price = $(this).data("price");
    var discount = $(this).data("discount");
    var compare = $(this).data("compare");
    var qty = $(this).val();
    $(".bundle_price").text(price);
    $(".quantity").val(qty);
    $(".label-content-bottom").slideUp();
    $(".product-bundle-btn").slideDown();

    var id = $("#subscription").val();
    subs(id);
  });

  $("#subscription").on("change", function () {
    var id = $(this).val();
    subs(id);
  });
});

function subs(id) {
  if ($("#subscription").prop("checked")) {
    $(".selling_plan").val(id);
    $(".quantity").val("1");
  } else {
    $(".selling_plan").val("");
  }
}
